export const cookieConsentValues = ['marketing', 'necessary'] as const;
export type CookieConsentValue = (typeof cookieConsentValues)[number];

export type ICookieConsentSelection = Record<CookieConsentValue, boolean>;
